import { render } from "./TrackingPage.vue?vue&type=template&id=590a8062"
import script from "./TrackingPage.vue?vue&type=script&lang=js"
export * from "./TrackingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__